var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicSentidos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A5F3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "senseGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0891B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0E7490"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "url(#bgGrad)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32, 32)",
    filter: "drop-shadow(0px 3px 2px rgba(14, 116, 144, 0.2))"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -18,0 C -10,-12 10,-12 18,0 C 10,12 -10,12 -18,0 Z",
    fill: "url(#senseGrad)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 7,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 3.5,
    fill: "#06B6D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: -2.5,
    r: 1.2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -15,-10 C -5,-16 5,-16 15,-10",
    fill: "none",
    stroke: "#0E7490",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -22,-6 C -25,-3 -25,3 -22,6",
    fill: "none",
    stroke: "#22D3EE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22,-6 C 25,-3 25,3 22,6",
    fill: "none",
    stroke: "#22D3EE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicSentidos);
export default __webpack_public_path__ + "static/media/topic_sentidos.91c53e888699761aeed2ff0bcffd2e02.svg";
export { ForwardRef as ReactComponent };